// extracted by mini-css-extract-plugin
export default {"container":"AfterCarousel_container__KBQg5","box":"AfterCarousel_box__4rZN-"};